// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root___mpx4","requiredAsterisk":"Info_requiredAsterisk__1kpmY"};